import { INTEGRATION_PROVIDERS } from '@vy/types';
import { oz } from '@vy/utils';

export const ProductErpFormInputSchema = oz.object({
  integrationProvider: oz.literal(INTEGRATION_PROVIDERS.netSuite),
  integrationExternalId: oz.string(),
  metadata: oz.object({
    name: oz.string(),
  }),
});

export type ProductErpFormInput = oz.infer<typeof ProductErpFormInputSchema>;
